import { Injectable } from '@angular/core';
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { IErrorResponse } from "./confirm-invitation.reducers";

import * as ConfirmInvitationSelectors from './confirm-invitation.selectors';
import * as ConfirmInvitationActions from './confirm-invitation.actions';
@Injectable({
  providedIn: 'root'
})
export class ConfirmInvitationFacadeService {

  checkInvitationUrl$: Observable<string> = this._store.select(ConfirmInvitationSelectors.checkConfirmUrl);
  checkInvitationUrlLoading$: Observable<boolean> = this._store.select(ConfirmInvitationSelectors.isCheckConfirmUrlLoading);
  confirmInvitationUrlError$: Observable<IErrorResponse | null> = this._store.select(ConfirmInvitationSelectors.confirmInvitationUrlError);
  confirmInvitationUrlCheckState$ = this._store.select(ConfirmInvitationSelectors.confirmInvitationUrlCheckState);

  constructor(private _store: Store) { }

  checkConfirmationUrl(url: string) {
    this._store.dispatch(ConfirmInvitationActions.fetchConfirmationSettings(url));
  }

  clearState() {
    this._store.dispatch(ConfirmInvitationActions.resetState());
  }
}
